import { CLIENT_ADD_ACTION_TYPE, CLIENT_DELETE_ACTION_TYPE, CLIENT_DETAIL_ACTION_TYPE, CLIENT_LIST_ACTION_TYPE } from "../../utils/constants";
const initialState = [];
function clientReducer(state=initialState,action){
    const{type,payload}=action;

    switch(type){
        case CLIENT_LIST_ACTION_TYPE:
            return [...state,payload];
        case CLIENT_ADD_ACTION_TYPE:
            return [...state,payload];
        case CLIENT_DETAIL_ACTION_TYPE:
            return [...state,payload];
        case CLIENT_DELETE_ACTION_TYPE:
            return [...state,payload];   
        default:
            return state;
    }
}
export default clientReducer;